import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { MultiStageGrowthReportInput } from '../../../../src/app/core/model/multi-stage-growth-report.model';
import { BaseComponent } from '../components/base.component';

@Injectable({
  providedIn: 'root',
})
export class StandaloneMultiStageGrowthReportResolver
  extends BaseComponent
  implements Resolve<MultiStageGrowthReportInput>, OnDestroy
{
  constructor() {
    super();
  }
  resolve(routeSnapshot: ActivatedRouteSnapshot): Observable<MultiStageGrowthReportInput> {
    const routeDetails = { ...routeSnapshot.params, ...routeSnapshot.queryParams };
    const { classId, rootProgramId, subject } = routeDetails;
    return of({ classId, rootProgramId, subject } as MultiStageGrowthReportInput);
  }

  ngOnDestroy(): void {
    this.destroy();
  }
}
